import Reveal from "@/components/Reveal";

const principles = [
  "Persönliche Betreuung",
  "Zuverlässige Abwicklung",
  "Faire und transparente Angebote",
  "Individuelle Lösungen",
  "Regionale Tätigkeit",
];

export default function AboutSection() {
  return (
    <section className="section about-section" id="ueber-uns" data-testid="trust-section">
      <div className="container about-grid">
        <Reveal className="about-statement">
          <span className="eyebrow">Über uns · 03 / 05</span>
          <h2 className="statement-title">Persönlich<br /><em>& zuverlässig.</em></h2>
        </Reveal>
        <Reveal className="about-copy" delay={120}>
          <p className="about-lead">VanAkkeren Räumungsservice ist ein lokaler Räumungs- und Umzugsservice aus Müllheim.</p>
          <p>Wir unterstützen Privatpersonen, Senioren, Angehörige, rechtliche Betreuer, Hausverwaltungen und Unternehmen bei Räumungen, Entrümpelungen, Haushaltsauflösungen und kleineren Umzügen.</p>
          <p>Was sensibel ist, darf unkompliziert bleiben: Wir hören zu, klären den Umfang und finden eine Lösung, die zu Ihrer Situation passt.</p>
          <ul className="principles-list">
            {principles.map((principle) => <li key={principle}><span>—</span>{principle}</li>)}
          </ul>
        </Reveal>
      </div>
    </section>
  );
}
